import store from "@/store";
import { CouponData, TokutenItem } from "@/model/Coupon";
import { InspectDetail } from "@/model/InspectDetail";

const namespace = "InspectionDetail";

export class InspectionTokutenDetailStoreService {
  private tokutenList: TokutenItem[] = [];
  deSelTokuten: boolean = false;

  // サービス初期化時に特典の選択管理枠をStoreへ登録する
  constructor() {
    this.addNowSelected();
  }

  // 特典が選択済みかどうかを参照する
  get nowSelected(): boolean {
    const nowSelected = store.getters[`${namespace}/getNowSelected`];
    if (nowSelected.tokuten === true || nowSelected.tokuten === false) {
      return nowSelected.tokuten;
    }
    this.addNowSelected();
    return false;
  }

  // 特典の選択管理枠をStoreへ追加する
  addNowSelected() {
    return store.dispatch(`${namespace}/addNowSelected`, "tokuten");
  }

  // 特典の選択済み状態をStoreへ反映する
  setNowSelected(payload: boolean) {
    return store.dispatch(`${namespace}/setNowSelected`, {
      key: "tokuten",
      value: payload
    });
  }

  // 共通処理から扱う特典一覧を参照する
  get list(): TokutenItem[] {
    return this.tokutenList;
  }

  // 共通処理から特典一覧を保持する
  setList(payload: TokutenItem[]) {
    this.tokutenList = payload;
  }

  // 特典の選択状態からスタート可否判定用の状態を更新する
  checkDisableStart(arrData: TokutenItem[], isUnSelect?: boolean) {
    let checked: boolean = false;
    if (isUnSelect) {
      checked = true;
    } else if (arrData) {
      checked = arrData.some((data: TokutenItem) => data.isCheck === 1);
    }
    this.setNowSelected(checked);
  }

  // テンプレート表示用の特典選択肢リストを生成する
  getTargetList() {
    return this.list.map((data: TokutenItem) => {
      const key = data.tokutenId || data.num;
      return {
        "mode": 1,
        "btnDel": false,
        "btnSel": data.isCheck === 1,
        "btnFre": !(data.isCheck === 1),
        "btnUse": false,
        "key": key,
        "dataSet": key,
        "isDisabled": false,
        "icon": "",
        "label": data.tokutenNm,
        "labelEntends1": 0,
        "labelEntends2": 0,
      };
    });
  }

  // スタート時に選択中の特典を保存データへ反映する
  setStartInspectDetail(inspectionDetail: InspectDetail) {
    inspectionDetail.tokuten = this.list
      .filter((data: TokutenItem) => data.isCheck === 1)
      .map((data: TokutenItem) => {
        return {
          num: data.num,
          tokutenId: data.tokutenId,
          tokutenNm: data.tokutenNm
        };
      });
  }

  // 取得済みの検査構成から特典の初期選択情報を反映する
  applyInitialInspectionDetail(data: any, inspectionDetail?: InspectDetail) {
    if (inspectionDetail) {
      inspectionDetail.tokuten = data.tokuten || [];
    }
    return { data, inspectionDetail };
  }

  // 特典の選択クリックを処理する
  select(key: number | string) {
    const tokutenList = this.list.map((data: TokutenItem) => {
      const dataKey = data.tokutenId || data.num;
      if (dataKey == key) {
        const isChecked = data.isCheck === 1;
        data.isCheck = isChecked ? 0 : 1;
        if (!isChecked) {
          this.deSelTokuten = false;
        }
      }
      return data;
    });
    this.setList(tokutenList);
    this.checkDisableStart(tokutenList, this.deSelTokuten);
  }

  // 特典で「選択無し」を表示できるか返す
  canDeSelect() {
    return true;
  }

  // 特典が「選択無し」状態か返す
  isDeSelected() {
    return this.deSelTokuten;
  }

  // 特典の「選択無し」状態を切り替える
  deSelect() {
    const tokutenList = this.list;
    if (!this.deSelTokuten) {
      tokutenList.map(data => (data.isCheck = 0));
    }
    this.deSelTokuten = !this.deSelTokuten;
    this.setList([...tokutenList]);
    this.checkDisableStart(tokutenList, this.deSelTokuten);
    return this.deSelTokuten;
  }

  // 共通呼び出し用の「選択無し」クリック処理
  clickDeSelect() {
    return this.deSelect();
  }

  // Storeに既存リストがある場合に選択状態を再評価する
  applyExistingList() {
    const tokutenList = this.list;
    this.checkDisableStart(tokutenList, this.deSelTokuten);
    return tokutenList;
  }

  // API取得結果から特典一覧の初期選択状態を作成する
  setInitialList(res: CouponData, selectedTokuten: TokutenItem[] | undefined, initialDeSelected?: boolean) {
    const responseItems = res && res.tokuten && res.tokuten.items ? res.tokuten.items : [];
    const tokutenList = responseItems.map((data: TokutenItem) => {
      const selected = selectedTokuten
        ? selectedTokuten.some((tokuten: TokutenItem) => data.tokutenId == tokuten.tokutenId)
        : false;
      data.isCheck = selected || data.isCheck === 1 ? 1 : 0;
      return data;
    });
    this.deSelTokuten = initialDeSelected === true
      && !tokutenList.some((data: TokutenItem) => data.isCheck === 1);
    this.setList(tokutenList);
    this.checkDisableStart(tokutenList, this.deSelTokuten);
    return tokutenList;
  }

  // 特典一覧を既存保持データまたはAPIから取得する
  getDataList(
    loadInitialList: () => Promise<CouponData>,
    selectedTokuten: TokutenItem[] | undefined,
    initialDeSelected?: boolean
  ) {
    if (this.list.length > 0) {
      this.applyExistingList();
      return {
        hasExistingList: true,
        promise: null
      };
    }
    return {
      hasExistingList: false,
      promise: loadInitialList().then((res: CouponData) => {
        return this.setInitialList(res, selectedTokuten, initialDeSelected);
      })
    };
  }
}
